import { IToggleEntry, Context, IFunction } from '../types'
import { gcfEndpoint } from '../constants'
import axios from 'axios'
import moment from 'moment'

export const getToggleData = (list: string[], checked: string[]) =>
  list.map((el) => ({ name: el, isChecked: checked.includes(el) }))

export const evalFnInClient = async (source: string) => {
  return new Promise((resolve) => {
    // eslint-disable-next-line
    const fn = new Function('moment', 'axios', source)
    fn(moment, axios)
      .then((res: any) => {
        resolve({
          result: 'success',
          output: res,
        })
      })
      .catch((err: any) => {
        resolve({
          result: 'error',
          error: err.message,
        })
      })
  })
}

export const evalFnInServer = async (payload: any) => {
  const resp = await fetch(gcfEndpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  })
  return resp.json()
}

export const getCheckedEntries = (entries: IToggleEntry[]) => {
  return entries && entries.filter((entry) => entry.isChecked).map((entry) => entry.name)
}

export interface IMappedContext {
  params: {
    [key: string]: string
  }
  a8config: {
    [key: string]: string
  }
  functions: IFunction[]
}

export const mapContext = (context: Context) => {
  const mappedContext: IMappedContext = {
    a8config: {},
    params: {},
    functions: context.functions,
  }

  mappedContext.params = mapTupleToObj(context.params)
  mappedContext.a8config = mapTupleToObj(context.a8config)

  return mappedContext
}

const mapTupleToObj = (arr: [string, string][]) => {
  const obj: { [key: string]: string } = {}

  arr.forEach((el) => {
    const [key, value] = el
    obj[key] = value
  })

  return obj
}

export const mapObjToTuple = (obj: { [key: string]: string}) => {
  const result: [string, string][] = []

  Object.keys(obj).forEach(el => {
    result.push([el, obj[el]])
  })

  return result
}

interface IPermissionEntries {
  a8config: IToggleEntry[]
  a8flow: IToggleEntry[]
  a8func: IToggleEntry[]
  a8Astro: IToggleEntry[]
}

export const mapPermissions = (entries: IPermissionEntries) => {
  return {
    a8config: getCheckedEntries(entries.a8config),
    a8flow: getCheckedEntries(entries.a8flow),
    a8func: getCheckedEntries(entries.a8func),
    a8Astro: getCheckedEntries(entries.a8Astro),
  }
}
